// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Testimonial_testimonial__1agKc","content":"Testimonial_content__2ZW3a","name":"Testimonial_name__1Npa_","description":"Testimonial_description__36lDk"};